import {
    finishCheckPerm,
    removeCheckPerm,
    updateCheckPermCount,
} from '../actions/permissionCheckerInternalActions';
import getPermissionCheckerInfo from '../selectors/getPermissionCheckerInfo';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';

orchestrator(finishCheckPerm, actionMessage => {
    const permissionCheckerInfo = getPermissionCheckerInfo(actionMessage.composeId);

    if (!permissionCheckerInfo) {
        trace.error('Finish check perm while tracker has not logged start. ');
    } else if (permissionCheckerInfo.pendingCheckPermCount > 1) {
        updateCheckPermCount(actionMessage.composeId, -1 /* count */);
    } else {
        removeCheckPerm(actionMessage.composeId);
    }
});
